import React, { useState } from 'react';
import Header from '../../../components/common/global-top-bar';
import SwitchBar from '../../../components/switch-bar';
import { PEER_NAVIGATION } from '../../peer-listing/peer-constants';
import { useScheduleHistory, ScheduleHistoryParams } from '../../../hooks/useScheduleReporting';
import { Spinner } from '../../../components/common';
import { usePeers } from '../../../hooks/usePeers';
import { TimezoneDisplay } from './history-constants';
import ScheduleHistoryTable from './history-table';
import ScheduleFilters from '../../../components/common/schedule-filter';

const ScheduleHistoryPage: React.FC = () => {
  const today = new Date();
  const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  const [timezoneDisplay, setTimezoneDisplay] = useState<string>(TimezoneDisplay.Central);
  const { data: listeners, isLoading: isListenersLoading } = usePeers({
    userType: ['peerlistener'],
    limit: 1000,
  });

  const [scheduleHistoryFilters, setScheduleHistoryFilters] = useState<ScheduleHistoryParams>({
    listener_role_ids: [],
    start_date: firstDayOfCurrentMonth.toISOString().split('T')[0],
    end_date: lastDayOfCurrentMonth.toISOString().split('T')[0],
  });
  const {
    data: scheduleHistory,
    isLoading: isScheduleHistoryLoading,
    isParamsValid,
  } = useScheduleHistory(scheduleHistoryFilters, timezoneDisplay);

  const isLoading = isListenersLoading || (isParamsValid && isScheduleHistoryLoading);

  return (
    <div>
      <Header heading="Schedule History" />
      <SwitchBar heading={PEER_NAVIGATION} position={2} />
      {isLoading && <Spinner />}
      <ScheduleFilters
        setScheduleHistoryFilters={setScheduleHistoryFilters}
        scheduleHistoryFilters={scheduleHistoryFilters}
        timezoneDisplay={timezoneDisplay}
        setTimezoneDisplay={setTimezoneDisplay}
        listeners={listeners?.data}
      />
      {scheduleHistory && <ScheduleHistoryTable scheduleHistory={scheduleHistory} />}
      {!isParamsValid && scheduleHistoryFilters.listener_role_ids.length === 0 && (
        <div className="p-4 text-center text-gray-500">
          Please select at least one listener to view schedule history
        </div>
      )}
    </div>
  );
};

export default ScheduleHistoryPage;
